import { z } from 'zod';
/**
 * Structured API error envelope.
 *
 * Returned by the backend for:
 *   - DomainError instances (400+, with typed `code`)
 *   - ZodError instances (400, with Zod `issues`)
 *
 * Legacy AppError uses a flat shape { error: string, code?: string } and is
 * NOT covered by this schema. See REFACTORING_DDD_PLAN.md §14 and
 * REFACTORING_FRONTEND_PLAN.md §14.
 */
export const ApiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        context: z.record(z.unknown()).optional(),
        issues: z.array(z.unknown()).optional(),
    }),
});
/**
 * Type guard for the structured shape. Use this in the frontend API client
 * before extracting `err.error.code`. For legacy AppError responses, fall
 * back to parsing `err.error` as a string.
 */
export function isStructuredApiError(value) {
    return ApiErrorSchema.safeParse(value).success;
}
//# sourceMappingURL=api-error.schema.js.map